export const DATE_FORMAT = 'DD.MM.YYYY';
export const TIME_FORMAT = 'HH:mm';
export const TIME_FORMAT_WITH_SECONDS = 'HH:mm:ss';
export const FULL_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

export const CLIENT_DATE_FORMAT = DATE_FORMAT;
export const SERVER_DATE_FORMAT = DATE_FORMAT;
